import { render, staticRenderFns } from "./PaxelMarketJoinProcedure.vue?vue&type=template&id=0324ab1c&"
import script from "./PaxelMarketJoinProcedure.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketJoinProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports